import { ApiCall } from '@web-shared/services/http-service/types/ApiCall';
import { httpService } from './http';
import { CreateBolParams } from './types/CreateBolParams';
import { EBOL_TOKEN_VALIDATION_STATUS } from './enums/ebol-token-validation-status';
import { EbolDetailsResponse, PodUploadResponse } from './types/EbolDetails';
import { UpdateEbolParams } from './types/UpdateEbolParams';
import { UploadPhotoParams } from './types/UploadPhotoParams';
import { EbolActionDetails } from './types/EbolActionDetails';

export const createBol = async (params: CreateBolParams) => {
  await httpService.post('/api/v3/ebol_management/ebols', params);
};

export const validateEbolToken: ApiCall<
  { token: string },
  { status: EBOL_TOKEN_VALIDATION_STATUS }
>
  = async ({ params, abortSignal }) => {
    const res = await httpService.post(
      '/api/v3/ebol_management/ebols/validate_ebol_reference',
      params,
      abortSignal
    );
    return res.data as { status: EBOL_TOKEN_VALIDATION_STATUS };
  };

export const showPublicBol: ApiCall<{ token: string }, EbolDetailsResponse> = async ({
  params,
  abortSignal
}) => {
  const res = await httpService.get(
    `/api/v3/public/secure_bol/ebol_references/${params.token}`,
    abortSignal
  );
  return res.data as EbolDetailsResponse;
};

export const uploadPodImage: ApiCall<UploadPhotoParams, PodUploadResponse> = async ({
  params
}) => {
  const res = await httpService.post(
    '/api/v3/public/secure_bol/ebol_photos',
    params,
  );
  return res.data as PodUploadResponse;
};

export const createAuditLog: ApiCall<{ token: string, position: GeolocationPosition }, void> = async ({
  params
}) => {
  const { token, position } = params;
  const data = {
    token,
    lat: position.coords.latitude,
    lng: position.coords.longitude,
    timestamp: new Date(position.timestamp).toISOString()
  };
  await httpService.post(
    '/api/v3/public/secure_bol/ebol_references/access',
    data,
  );
};

export const updateEbol: ApiCall<UpdateEbolParams, EbolActionDetails> = async ({ params: { id, ...restParams }, abortSignal }) => {
  const res = await httpService.put(
    `/api/v3/public/secure_bol/ebols/${id.toString()}`,
    restParams,
    abortSignal
  );
  return res.data as EbolActionDetails;
};